/**
 * 智慧通行顶栏：从其它菜单组抽取项，作为本顶栏下的二级菜单组展示。
 * 「开门记录」来源：首页树下独立组，或「设备管理」对应「设备」组下的子项。
 */
export const SMART_TRAFFIC_VIRTUAL_ID = 'smartTraffic'

export const RELOCATED_GROUP_IDS = {
  itemRelease: 'relocated_item_release',
  openRecord: 'relocated_open_record'
}

export function findMenuByLangKey(menus, menuKey, getLangValuesByKey, normalizeMenuName) {
  if (!menus || !menus.length) {
    return null
  }
  const labels = getLangValuesByKey(menuKey).map(normalizeMenuName)
  return menus.find(menu => labels.includes(normalizeMenuName(menu.name))) || null
}

export function findChildByLangKey(parent, childKey, getLangValuesByKey, normalizeMenuName) {
  if (!parent || !parent.childs || !parent.childs.length) {
    return null
  }
  const labels = getLangValuesByKey(childKey).map(normalizeMenuName)
  return parent.childs.find(child => labels.includes(normalizeMenuName(child.name))) || null
}

/** 从父组 childs 中抽出三级项，包装为二级菜单组（单页面包在 childs 里供 switchMenu 使用） */
export function promoteChildToGroup(parentGroup, childKey, relocatedId, getLangValuesByKey, normalizeMenuName) {
  const child = findChildByLangKey(parentGroup, childKey, getLangValuesByKey, normalizeMenuName)
  if (!child) {
    return null
  }
  const childNorm = normalizeMenuName(child.name)
  parentGroup.childs = parentGroup.childs.filter(c => normalizeMenuName(c.name) !== childNorm)
  return {
    id: relocatedId,
    name: child.name,
    icon: parentGroup.icon || 'fa-file',
    seq: child.seq || 99,
    directNavigate: true,
    childs: [JSON.parse(JSON.stringify(child))]
  }
}

/** 从一级菜单组列表中整组抽出 */
export function extractGroupFromMenus(menus, groupKey, relocatedId, getLangValuesByKey, normalizeMenuName) {
  const labels = getLangValuesByKey(groupKey).map(normalizeMenuName)
  const idx = menus.findIndex(menu => labels.includes(normalizeMenuName(menu.name)))
  if (idx < 0) {
    return null
  }
  const group = JSON.parse(JSON.stringify(menus[idx]))
  group.id = relocatedId
  menus.splice(idx, 1)
  return group
}

function markDirectNavigateGroup(group) {
  if (group) {
    group.directNavigate = true
  }
  return group
}

export function isOpenRecordGroup(menu, getLangValuesByKey, normalizeMenuName) {
  return !!findMenuByLangKey([menu], 'menuItemOpenRecord', getLangValuesByKey, normalizeMenuName)
}

/** 开门记录：先按独立组名匹配，再按「设备」组下的子项匹配 */
export function extractOpenRecordGroup(workingMenus, getLangValuesByKey, normalizeMenuName) {
  let group = extractGroupFromMenus(
    workingMenus,
    'menuItemOpenRecord',
    RELOCATED_GROUP_IDS.openRecord,
    getLangValuesByKey,
    normalizeMenuName
  )
  if (group) {
    return markDirectNavigateGroup(group)
  }
  const machineGroup = findMenuByLangKey(workingMenus, 'menuGroupMachine', getLangValuesByKey, normalizeMenuName)
  if (!machineGroup) {
    return null
  }
  return promoteChildToGroup(
    machineGroup,
    'menuItemOpenRecord',
    RELOCATED_GROUP_IDS.openRecord,
    getLangValuesByKey,
    normalizeMenuName
  )
}

export function stripMenusRelocatedToSmartTraffic(workingMenus, getLangValuesByKey, normalizeMenuName) {
  const communityGroup = findMenuByLangKey(workingMenus, 'menuGroupCommunity', getLangValuesByKey, normalizeMenuName)
  if (communityGroup) {
    promoteChildToGroup(
      communityGroup,
      'menuItemItemRelease',
      RELOCATED_GROUP_IDS.itemRelease,
      getLangValuesByKey,
      normalizeMenuName
    )
  }
  extractOpenRecordGroup(workingMenus, getLangValuesByKey, normalizeMenuName)
}

export function collectSmartTrafficRelocatedGroups(workingMenus, getLangValuesByKey, normalizeMenuName) {
  const relocated = []

  const communityGroup = findMenuByLangKey(workingMenus, 'menuGroupCommunity', getLangValuesByKey, normalizeMenuName)
  if (communityGroup) {
    const itemReleaseGroup = promoteChildToGroup(
      communityGroup,
      'menuItemItemRelease',
      RELOCATED_GROUP_IDS.itemRelease,
      getLangValuesByKey,
      normalizeMenuName
    )
    if (itemReleaseGroup) {
      relocated.push(itemReleaseGroup)
    }
  }

  const openRecordGroup = extractOpenRecordGroup(workingMenus, getLangValuesByKey, normalizeMenuName)
  if (openRecordGroup) {
    relocated.push(openRecordGroup)
  }

  return relocated
}

export function hasSmartTrafficContent(baseMenus, getLangValuesByKey, normalizeMenuName) {
  const parkingLabels = getLangValuesByKey('menuGroupParking').map(normalizeMenuName)
  const hasParking = (baseMenus || []).some(menu => parkingLabels.includes(normalizeMenuName(menu.name)))
  if (hasParking) {
    return true
  }
  const community = findMenuByLangKey(baseMenus, 'menuGroupCommunity', getLangValuesByKey, normalizeMenuName)
  if (community && findChildByLangKey(community, 'menuItemItemRelease', getLangValuesByKey, normalizeMenuName)) {
    return true
  }
  if (findMenuByLangKey(baseMenus, 'menuItemOpenRecord', getLangValuesByKey, normalizeMenuName)) {
    return true
  }
  const machine = findMenuByLangKey(baseMenus, 'menuGroupMachine', getLangValuesByKey, normalizeMenuName)
  if (machine && findChildByLangKey(machine, 'menuItemOpenRecord', getLangValuesByKey, normalizeMenuName)) {
    return true
  }
  return false
}
